export class ApiError extends Error {
  status: number
  code: number
  constructor(message: string, status: number, code: number) {
    super(message)
    this.name = 'API Error'
    this.status = status
    this.code = code
  }
}

/** 只信任 ApiError 的訊息，其他一律回傳 fallbackMessage */
export function getApiErrorMessage(error: unknown, fallbackMessage: string): string {
  return error instanceof ApiError && error.message ? error.message : fallbackMessage
}
